import axios, { AxiosPromise } from 'axios';
import { getSecurityUrl }      from '@/service/service.helpers';
import { LoginFormFields }     from '@/views/login/login.types';

export function loginUser({ password, username }: LoginFormFields): AxiosPromise {
  return axios.post(getSecurityUrl('/user/login'), {
    password,
    login: username,
    role: 'ROLE_CLIENT',
  });
}
